export default __webpack_public_path__ + "static/media/Home-Value-Bichronous.1553ee03.jpg";